import(/* webpackMode: "eager", webpackExports: ["LandingShell"] */ "/vercel/path0/frontend/src/components/LandingShell.tsx");
